export default __webpack_public_path__ + "static/google-87732be5199495da4e3d862e35ecfc87.png";